import React, { useEffect, useState } from 'react';
import { getProgressPercentage, getProgressBgColor } from '../../utils/calculations';
interface ProgressBarProps {
  current: number;
  goal: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}
const sizeClasses: Record<string, string> = {
  sm: 'h-1.5',
  md: 'h-2.5',
  lg: 'h-4'
};
export function ProgressBar({
  current,
  goal,
  size = 'md',
  showLabel = true
}: ProgressBarProps) {
  const [animatedWidth, setAnimatedWidth] = useState(0);
  const percentage = getProgressPercentage(current, goal);
  const clampedPercentage = Math.min(percentage, 100);
  const barColor = getProgressBgColor(percentage);
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedWidth(clampedPercentage);
    }, 50);
    return () => clearTimeout(timer);
  }, [clampedPercentage]);
  return <div className="w-full" data-id="element-302">
      <div className={`w-full bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden ${sizeClasses[size]}`} role="progressbar" aria-valuenow={current} aria-valuemin={0} aria-valuemax={goal} aria-label={`${current} of ${goal} (${percentage}%)`} data-id="element-303">
        <div className={`${barColor} rounded-full transition-all duration-700 ease-out ${sizeClasses[size]}`} style={{
        width: `${animatedWidth}%`
      }} data-id="element-304" />
      </div>
      {showLabel && <div className="flex items-center justify-between mt-1" data-id="element-305">
          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-306">
            {current} / {goal}
          </span>
          <span className="text-xs font-medium text-gray-700 dark:text-gray-300" data-id="element-307">
            {percentage}%
          </span>
        </div>}
    </div>;
}